import { FC } from "react";

export const Agreement = () => {
  return (
    <div className="official_pages">
      <h2>Публичный договор-оферта по оказанию услуг обучения</h2>

      <p>
        Данный договор является официальной публичной офертой и содержит все существенные условия по оказанию услуг
        обучения.
      </p>
      <p>
        В случае оплаты образовательных услуг или использования любой бесплатной образовательной услуги, юридическое или
        физическое лицо, производящее акцепт настоящей оферты, становится Заказчиком, а Исполнитель и Заказчик совместно
        – Сторонами настоящего договора.
      </p>
      <p>
        Внимательно прочитайте текст настоящей публичной оферты и ознакомьтесь с прейскурантом услуг, изложенным на
        сайте Исполнителя. Если Вы не согласны с каким-либо пунктом оферты, Исполнитель предлагает Вам отказаться от
        использования услуг.
      </p>
      <p>1. Общие понятия</p>
      <p>
        1.1. Акцепт оферты — полное и безоговорочное принятие оферты путем оплаты образовательной услуги или посещения
        любого бесплатного образовательного мероприятия Заказчиком. Акцепт оферты создает договор между Исполнителем и
        Заказчиком.
      </p>
      <p>
        1.2. Заказчик — лицо, осуществившее акцепт оферты и ставшее, таким образом, Заказчиком услуг Исполнителя по
        заключенному договору оферты.
      </p>
      <p>
        1.3. Исполнитель — Администрация интернет-ресурсов https://kindbot.pro/.
      </p>
      <p>
        1.4. Договор оферты — договор между Исполнителем и Заказчиком на оказание услуг обучения, который заключается
        посредством акцепта оферты.
      </p>
      <p>
        1.5. Прейскурант — действующий систематизированный перечень услуг обучения Исполнителя с указанием цен,
        публикуемый на интернет-ресурсах по адресу: https://kindbot.pro/.
      </p>
      <p>2. Предмет договора</p>
      <p>
        2.1. Предметом настоящей оферты является оказание Заказчику услуг обучения в соответствии с условиями настоящей
        оферты и текущим прейскурантом услуг Исполнителя.
      </p>
      <p>
        2.2. Перечень оказываемых услуг указан на интернет-ресурсе по адресу: https://kindbot.pro/.
      </p>
      <p>
        2.3. Исполнитель имеет право в одностороннем порядке изменять прейскурант и условия настоящей публичной оферты
        без предварительного согласования с Заказчиком, обеспечивая при этом публикацию измененных условий на
        интернет-ресурсе по адресу: https://kindbot.pro/agreement, не менее чем за три дня до их вступления в
        силу.
      </p>
      <p>3. Порядок оказания и оплаты услуг</p>
      <p>
        3.1. Платные услуги обучения предоставляются в полном объеме при условии их 100%-ной (сто процентов) оплаты
        Заказчиком. Программой некоторых образовательных услуг может быть предусмотрена рассрочка или предоплата. В
        случае отказа Заказчика от обучения, а также неявки на занятия, внесенная предоплата Заказчику не возвращается.
      </p>
      <p>
        3.2. Заказчик перечисляет денежные средства на расчетный счет Исполнителя через онлайн-платежную систему на
        сайте, либо вносит наличные в кассу Исполнителя, либо оплачивает услуги Исполнителя иными доступными способами в
        соответствии с прейскурантом, либо использует образовательную услугу Исполнителя бесплатно в случае если
        образовательное мероприятие Исполнителя проводится бесплатно.
      </p>
      <p>
        3.5. Договор оферты вступает в силу после оплаты услуг Исполнителя и/или посещения Заказчиком любого из
        бесплатных образовательных мероприятий, проводимых Исполнителем.
      </p>
      <p>
        3.6. С момента акцепта оферты Исполнитель обязуется предоставить платные услуги обучения Заказчику в сроки,
        установленные образовательной программой.
      </p>
      <p>4. Права и обязанности сторон, ответственность</p>
      <p>
        4.1. Исполнитель прилагает все усилия для обеспечения качественного и бесперебойного предоставления услуг
        Заказчику в соответствии с программой образовательной услуги.
      </p>
      <p>
        4.2. Заказчик проходит обучение в установленные сроки, получая доступ ко всем инструментам обучения, указанным в
        предложении услуги.
      </p>
      <p>
        4.3. Заказчику запрещается публиковать информацию о продуктах, созданных в результате обучения, либо о
        продуктах, созданных после обучения на основе метода, представленного Исполнителем, на любых сайтах, новостных
        порталах, блогах, в социальных сетях и других онлайн-ресурсах без письменного согласия Исполнителя. В случае
        нарушения данного положения Заказчик несет ответственность в размере не менее 5 000 000 (пяти миллионов) рублей
        или 50 000 (пятидесяти тысяч) евро за каждый факт несогласованной публикации, либо в большем размере, если ущерб
        или упущенная выгода Исполнителя превысит эту сумму.
      </p>
      <p>
        Данное положение не распространяется на публикацию продуктов, созданных на основе метода Исполнителя, в
        интернет-магазинах приложений и/или расширений, а также на иных онлайн-ресурсах, используемых для загрузки
        продукта конечным клиентом Заказчика, в случае если эти публикации не раскрывают аспектов подбора идеи,
        прототипирования, валидации, разработки, продвижения и других деталей и процессов разработки продуктов,
        созданных во время или после обучения на основе метода, представленного Исполнителем.
      </p>
      <p>
        4.4. Заказчику запрещается копировать, перерабатывать и/или распространять каким-либо способом материалы сайта,
        курсов и уроков Исполнителя, включая публикацию информации, полностью или частично раскрывающей метод запуска
        продуктов, представленный Исполнителем, без его письменного согласия. В случае нарушения данного положения
        Заказчик несет ответственность в размере не менее 5 000 000 (пяти миллионов) рублей или 50 000 (пятидесяти
        тысяч) евро за каждый факт несогласованной публикации, либо в большем размере, если ущерб или упущенная выгода
        Исполнителя превысит эту сумму.
      </p>
      <p>
        4.5. В случае попыток или фактов незаконных действий со стороны Заказчика, Исполнитель вправе отказать в
        предоставлении услуг, а также привлечь Заказчика к ответственности в соответствии с действующим
        законодательством за незаконное копирование и распространение материалов.
      </p>
      <p>
        4.6. Заказчику запрещено создавать конкурентные Исполнителю сообщества, каналы, комьюнити, курсы, сайты и другие
        материалы, связанные с созданием продуктов в IT-сфере, на основе переработанных или оригинальных материалов
        сайта, курсов, уроков и других материалов Исполнителя.
      </p>
      <p>
        4.7. Исполнитель оставляет за собой право публиковать информацию о продуктах Заказчика, созданных в результате
        обучения, либо о продуктах, созданных после обучения на основе метода Исполнителя, с согласия Заказчика.
      </p>
      <p>
        4.8. Исполнитель не несет ответственности за нарушение условий оферты, если такое нарушение вызвано
        обстоятельствами непреодолимой силы (форс-мажор), включая действия государственных органов, пожар, наводнение,
        землетрясение, другие стихийные бедствия, отсутствие электроэнергии и/или сбои в работе компьютерных сетей,
        забастовки, гражданские волнения, беспорядки и любые другие обстоятельства, которые могут повлиять на выполнение
        условий настоящей оферты и неподконтрольны Исполнителю.
      </p>
      <p>
        4.9. В случае невозможности оказания услуг по вине Исполнителя, Исполнитель обязуется вернуть Заказчику
        уплаченные денежные средства. В иных случаях возврат денежных средств не производится.
      </p>
      <p>
        4.10. В случае, если Заказчик по собственной инициативе или по причине, зависящей от него, не воспользовался
        предоставленными образовательными услугами в установленный срок, такие образовательные услуги считаются
        оказанными надлежащим образом и в полном объеме и возврат денежных средств в таком случае не производится.
      </p>
      <p>
        4.11. Заказчик подтверждает свое согласие с тем, что образовательные услуги и цифровые продукты предоставляются
        Исполнителем в том виде, в каком они существуют на момент оказания. Заказчик не вправе требовать внесения
        изменений, доработок или дополнений в оказанные образовательные услуги, предоставленные продукты, их отдельные
        элементы либо образовательные материалы, а также изменения условий предоставления доступа, установленных
        настоящим Договором.
      </p>
      <p>5. Заключительные положения</p>
      <p>
        5.1. Договор вступает в силу с момента акцепта оферты и действует до полного выполнения Сторонами своих
        обязательств. Доказательством акцепта оферты считаются материалы Исполнителя, подтверждающие оплату
        образовательных услуг Заказчиком, и/или доказательства факта посещения Заказчиком любых бесплатных
        образовательных мероприятий, проводимых Исполнителем, либо получения доступа к платным или бесплатным
        образовательным материалам Заказчиком.
      </p>
      <p>
        5.2. В случае возникновения споров по вопросам, предусмотренным настоящим Договором, или в связи с ним,
        Исполнитель и Заказчик примут меры для их разрешения путем переговоров между Сторонами. Срок рассмотрения
        претензии – 15 (пятнадцать) рабочих дней.
      </p>
      <p>
        5.3. В случае невозможности урегулирования споров по настоящему Договору или в связи с ним путем переговоров,
        такие споры подлежат рассмотрению в соответствии с действующим законодательством Великобритании.
      </p>
      <p>
        5.4. В случае проведения Исполнителем Акций, предоставляющих различные скидки, скидки по промокоду не
        суммируются с другими скидками и специальными предложениями Исполнителя.
      </p>
    </div>
  );
};
